export enum ActionMenuIconSize {
    SMALL = 14,
    DEFAULT = 24
}
